import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import EmojiPickers from 'components/Emoj';
import {
  CommentInputBox,
  CommentContainer,
  CommentBox,
  CommentUserDetails,
} from 'pages/home/Content.style';
import { CaretDownOutlined } from '@ant-design/icons';
import {
  CustomisePopover,
  Button,
  Virtuoso,
  Input,
  BasicIconButton,
} from 'components';
import { EndStyle, UserProfile } from './Home.style';
import BasicPopover from 'components/Popover';
import { JobAlertPopover } from 'pages/jobs/JobPosts.style';
import { Notification } from 'components/CustomNotification';
import {
  deleteCommentsReply,
  getCommentBypostId,
} from 'redux/features/CommentSlice';
import { AddCommentLikes, AddReplyLikes } from 'redux/services/LikeService';
import { AddComment, AddCommentsReply } from 'redux/services/CommentService';

import { ReactComponent as ProfilePic } from 'assert/images/Common/profileImg.svg';
import { ReactComponent as Like } from 'assert/images/Common/thumbUp.svg';
import { ReactComponent as DisLike } from 'assert/images/Common/thumbDown.svg';
import { ReactComponent as FillLike } from 'assert/images/Common/thumbUpFilled.svg';
import { ReactComponent as FillDisLike } from 'assert/images/Common/thumbDownFilled.svg';
import { ReactComponent as Delete } from 'assert/images/More/delete.svg';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const size = 20;

const Comments = ({
  postId,
  isDetailPage,
  detailPost,
  currentTime,
  disableCmt,
  postData,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { getProfile } = useSelector((state) => state?.ProfileSlice);
  const { getCommentReaction } = useSelector((state) => state.ReactionSlice);
  const userId = getProfile?.userId;

  const [page, setPage] = useState(0);
  const [replycount, setreplycount] = useState(10);
  const [CommentList, setCommentList] = useState([]);
  const [isAlertPopoverOpen, setIsAlertPopoverOpen] = useState(false);
  const [showReplyByIndex, setShowReplyByIndex] = useState(null);
  const [showReplyComment, setShowReplyComment] = useState([]);
  const [commentValue, setCommentValue] = useState({
    mainComment: '',
    replyComment: '',
  });
  const [UserComments, setUserComments] = useState({
    commentlike: {},
    commentdislike: {},
    replylike: {},
    replydislike: {},
    commentList: [],
    hasMore: 0,
  });
  useEffect(() => {
    if (getProfile?.userId) {
      isDetailPage && window.scroll(0, 0);
      dispatch(
        getCommentBypostId(postId, currentTime, 0, 20, getProfile?.userId)
      ).then((response) => {
        setCommentList(response.data?.rows || []);
        setUserComments((prev) => {
          const newCommentLike = { ...prev.commentlike };
          const newCommentDislike = { ...prev.commentdislike };
          const newReplyLike = { ...prev.replylike };
          const newReplyDislike = { ...prev.replydislike };

          response.data?.rows.forEach((val) => {
            newCommentLike[val.id] = val?.isLiked === 1;
            newCommentDislike[val.id] = val?.isUnLiked === 1;
            val?.replies?.forEach((reply) => {
              newReplyLike[reply.id] = reply?.isLiked === 1;
              newReplyDislike[reply.id] = reply?.isUnLiked === 1;
            });
          });

          return {
            ...prev,
            commentlike: newCommentLike,
            commentdislike: newCommentDislike,
            replylike: newReplyLike,
            replydislike: newReplyDislike,
            hasMore: response.data?.hasMore,
          };
        });
      });
    }
  }, [getProfile.userId]);

  // useEffect(() => {
  //   console.log("CommentList", CommentList);
  //   CommentList.forEach((val) => {
  //     console.log("UserComments.commentlike", UserComments.commentlike[val.id]);
  //     UserComments.commentlike[val.id] = val?.isLiked === 1;
  //     UserComments.commentdislike[val.id] = val?.isUnLiked === 1;
  //     val?.replies?.forEach((reply) => {
  //       UserComments.replylike[reply.id] = reply?.isLiked === 1;
  //       UserComments.replydislike[reply.id] = reply?.isUnLiked === 1;
  //     });
  //   });
  //   setUserComments((prev) => ({
  //     ...prev,
  //   }));
  // }, [CommentList]);

  const handleChange = (data, key) => {
    setCommentValue((prev) => ({
      ...prev,
      [key]: data,
    }));
  };

  const showReplyInput = (index) => {
    setCommentValue((prevState) => ({
      ...prevState,
      replyComment: '',
    }));
    setShowReplyByIndex(index === showReplyByIndex ? null : index);
  };

  const handleSetCommentIndex = (index) => {
    if (showReplyComment.includes(index)) {
      setShowReplyComment(showReplyComment.filter((item) => item !== index));
    } else {
      setShowReplyComment([...showReplyComment, index]);
    }
  };

  const postComment = (key, data) => {
    if (key === 'mainComment') {
      AddComment({
        commenterId: userId,
        postId,
        comment: commentValue.mainComment,
        clientOffSet: new Date().getTimezoneOffset(),
      }).then((val) => {
        const addData = [...CommentList];
        const cmtId = val.data?.id;
        if (val.success === true) {
          addData.unshift(val.data);
          UserComments.commentlike[cmtId] = 0;
          UserComments.commentdislike[cmtId] = 0;
          // UserComments.commentCount = UserComments.commentCount + 1;
          setUserComments((prev) => ({
            ...prev,
          }));
          setCommentList(addData);
          setCommentValue((prev) => ({
            ...prev,
            mainComment: '',
          }));
        }
      });
    } else if (key === 'replyComment') {
      AddCommentsReply({
        commentId: data.id,
        reply: commentValue.replyComment,

        replierId: userId,
        repliedByName: getProfile?.username,
        commentedById: data?.user_id,

        postId,
        postCreatedById: Number(postData?.createdById || 0),
        clientOffSet: new Date().getTimezoneOffset(),
      }).then((val) => {
        if (val.success === true) {
          const replyId = val.data?.id;
          const addData = {
            user_id: getProfile?.userId,
            username: getProfile?.username,
            displayName: null,
            profileImage: '',
            ...val.data,
          };
          UserComments.replylike[replyId] = 0;
          UserComments.replydislike[replyId] = 0;
          setUserComments((prev) => ({
            ...prev,
          }));
          setCommentValue((prev) => ({
            ...prev,
            replyComment: '',
          }));
          setCommentList(
            CommentList?.map((elem) => {
              return elem.id === data.id
                ? { ...elem, replies: [...(elem?.replies || []), addData] }
                : elem;
            })
          );
        }
      });
    }
    setShowReplyByIndex(null);
  };

  const getInput = (key, data, type) => (
    <CommentInputBox type={type}>
      <UserProfile>
        {getProfile?.profileImage ? (
          <img
            src={getProfile?.profileImage}
            className="profile-pic"
            alt="profile-picture"
          />
        ) : (
          <ProfilePic />
        )}
      </UserProfile>
      <Input
        placeholder={
          key === 'mainComment'
            ? t('HomePage.Comment')
            : t('HomePage.ReplyPlaceHolder')
        }
        onChange={(data) => handleChange(data, key)}
        value={commentValue[key]}
        className="comment-textarea"
        multiline
        maxLimit={2000}
      />
      <div className="reply-action">
        <CustomisePopover
          content={
            <EmojiPickers onEmojiClick={(val) => onEmojiClick(val, key)} />
          }
        />
        <Button
          disabled={commentValue[key]?.trim() === ''}
          customStyles="postBtn"
          label={t('HomePage.Send')}
          onClick={() => commentValue[key] !== '' && postComment(key, data)}
        />
      </div>
    </CommentInputBox>
  );

  const onEmojiClick = (emojiData, key) => {
    if (key === 'replyComment') {
      commentValue.replyComment = commentValue.replyComment + emojiData.emoji;
    } else {
      commentValue.mainComment = commentValue.mainComment + emojiData.emoji;
    }
    setCommentValue((prev) => ({
      ...prev,
    }));
  };

  const Morecontent = (data) => {
    if (data.length > replycount) {
      setreplycount(replycount + 10);
    }
  };

  const LikeAndDislikeActions = (data, typebased, type) => {
    let payload = {
      likedId: Number(userId),
    };
    // setUserComments((prev) => ({
    //   ...prev,
    // }));
    switch (type) {
      case 'commentlike':
        payload = {
          ...payload,
          like: !UserComments.commentlike[data.id],
          commentId: data.id,
        };
        break;
      case 'replylike':
        payload = {
          ...payload,
          like: !UserComments.replylike[data.id],
          replyId: data.id,
        };
        break;
      case 'commentdislike':
        payload = {
          ...payload,
          like: UserComments.commentdislike[data.id],
          commentId: data.id,
        };
        break;
      case 'replydislike':
        payload = {
          ...payload,
          like: UserComments.replydislike[data.id],
          replyId: data.id,
        };
        break;
      default:
        break;
    }

    if (typebased === 'maincomment') {
      let method = 'delete';
      if (
        type === 'commentlike' &&
        (UserComments.commentlike[data.id] === false ||
          UserComments.commentlike[data.id] === 0)
      ) {
        method = 'post';
      } else if (
        type === 'commentdislike' &&
        (UserComments.commentdislike[data.id] === false ||
          UserComments.commentlike[data.id] === 0)
      ) {
        method = 'post';
      } else {
        method = 'delete';
      }

      AddCommentLikes(payload, method, postId)
        .then(() => {
          setUserComments((prev) => {
            const newCommentLike = { ...prev.commentlike };
            const newCommentDislike = { ...prev.commentdislike };
            if (type === 'commentlike') {
              newCommentLike[data.id] = !newCommentLike[data.id];
              newCommentDislike[data.id] = false;
            } else if (type === 'commentdislike') {
              newCommentDislike[data.id] = !newCommentDislike[data.id];
              newCommentLike[data.id] = false;
            }
            return {
              ...prev,
              commentlike: newCommentLike,
              commentdislike: newCommentDislike,
            };
          });
        })
        .catch((err) => {
          Notification('warning', err.response?.data?.message);
        });
    } else {
      AddReplyLikes(
        payload,
        type === 'replylike'
          ? !UserComments.replylike[data.id]
            ? 'post'
            : 'delete'
          : !UserComments.replydislike[data.id]
          ? 'post'
          : 'delete',
        postId
      )
        .then(() => {
          if (type === 'replylike') {
            UserComments.replylike[data.id] = !UserComments.replylike[data.id];
            UserComments.replydislike[data.id] = false;
          } else if (type === 'replydislike') {
            UserComments.replydislike[data.id] =
              !UserComments.replydislike[data.id];
            UserComments.replylike[data.id] = false;
          }
          setUserComments((prev) => ({
            ...prev,
          }));
        })
        .catch((err) => {
          Notification('warning', err.response?.data?.message);
        });
    }

    setUserComments((prev) => ({
      ...prev,
    }));
  };

  const CommentFun = (data, typebased) => (
    <span>
      <>
        <span
          onClick={() => LikeAndDislikeActions(data, typebased, 'commentlike')}
        >
          {UserComments.commentlike[data.id] ? <FillLike /> : <Like />}
        </span>
        <span>
          {data?.comment_liked !== '0' && data?.comment_liked !== 0
            ? data?.comment_liked
            : ''}
        </span>
      </>
      <>
        <span
          onClick={() =>
            LikeAndDislikeActions(data, typebased, 'commentdislike')
          }
        >
          {UserComments.commentdislike[data.id] ? <FillDisLike /> : <DisLike />}
        </span>
        <span>
          {data?.comment_unLiked !== '0' && data?.comment_unLiked !== 0
            ? data?.comment_unLiked
            : ''}
        </span>
      </>
    </span>
  );

  const ReplyCommentFun = (data, typebased) => (
    <span>
      <>
        <span
          onClick={() => LikeAndDislikeActions(data, typebased, 'replylike')}
        >
          {UserComments.replylike[data.id] ? <FillLike /> : <Like />}
        </span>
        <span>{data?.reply_liked !== 0 ? data?.reply_liked : ''}</span>
      </>
      <>
        <span
          onClick={() => LikeAndDislikeActions(data, typebased, 'replydislike')}
        >
          {UserComments.replydislike[data.id] ? <FillDisLike /> : <DisLike />}
        </span>
        <span>{data?.reply_unLiked !== 0 ? data?.reply_unLiked : ''}</span>
      </>
    </span>
  );

  const ActionsRender = (data, typebased) => {
    return (
      <div className="actions-like">
        {typebased === 'maincomment'
          ? CommentFun(data, typebased)
          : ReplyCommentFun(data, typebased)}
      </div>
    );
  };

  const handleDelete = (id, type, parentId) => {
    setIsAlertPopoverOpen(false);
    dispatch(deleteCommentsReply(id, type)).then((res) => {
      if (res?.data?.status) {
        if (type === 'comments') {
          // UserComments.commentCount = UserComments.commentCount - 1;
          setUserComments((prev) => ({
            ...prev,
          }));
          setCommentList(CommentList.filter((item) => item.id !== id));
        } else {
          setCommentList(
            CommentList?.map((elem) => {
              return elem.id === parentId
                ? {
                    ...elem,
                    replies: elem?.replies?.filter((item) => item.id !== id),
                  }
                : elem;
            })
          );
        }
      }
      Notification('success', res?.data?.message);
    });
  };

  const handleRenderPopup = (data, type, parentId) => {
    return (
      <BasicPopover
        handlePopoverClick={() => setIsAlertPopoverOpen(true)}
        isOpen={isAlertPopoverOpen}
        action={
          <div className="remove-icon">
            <BasicIconButton
              icon={<Delete />}
              ariaLabel={'remove-icon'}
              size="small"
            />
          </div>
        }
        content={
          <JobAlertPopover className="job-alert-popover">
            {t('HomePage.ReplyDel')}
            <div>
              <Button
                variant="text"
                color="error"
                label={t('HomePage.Yes')}
                onClick={() => {
                  handleDelete(data.id, type, parentId);
                }}
              />
              <Button
                variant="text"
                label={t('HomePage.No')}
                onClick={() => setIsAlertPopoverOpen(false)}
              />
            </div>
          </JobAlertPopover>
        }
      />
    );
  };

  const fetchMoreData = () => {
    if (UserComments.hasMore) {
      const pageCount = page + 1;
      setPage(pageCount);
      dispatch(
        getCommentBypostId(
          postId,
          currentTime,
          pageCount,
          size,
          getProfile?.userId
        )
      ).then((response) => {
        const cmtList = CommentList.concat(...response.data?.rows);
        setCommentList(cmtList);
        setUserComments((prev) => {
          const newCommentLike = { ...prev.commentlike };
          const newCommentDislike = { ...prev.commentdislike };
          const newReplyLike = { ...prev.replylike };
          const newReplyDislike = { ...prev.replydislike };

          cmtList.forEach((val) => {
            newCommentLike[val.id] = val?.isLiked === 1;
            newCommentDislike[val.id] = val?.isUnLiked === 1;
            val?.replies?.forEach((reply) => {
              newReplyLike[reply.id] = reply?.isLiked === 1;
              newReplyDislike[reply.id] = reply?.isUnLiked === 1;
            });
          });

          return {
            ...prev,
            commentlike: newCommentLike,
            commentdislike: newCommentDislike,
            replylike: newReplyLike,
            replydislike: newReplyDislike,
            hasMore: response.data?.hasMore,
          };
        });
      });
    }
  };
  return (
    <CommentContainer isDetailPage={isDetailPage}>
      {isDetailPage && <div className="detail-single-post">{detailPost}</div>}
      {disableCmt ? getInput('mainComment') : ''}
      {disableCmt ? (
        <CommentBox>
          {CommentList?.length > 0 ? (
            <Virtuoso
              data={CommentList}
              minHeight="72vh"
              useWindowScroll={isDetailPage}
              components={{
                Footer: () => {
                  return (
                    !UserComments?.hasMore && (
                      <EndStyle>
                        <span>* * *</span>
                      </EndStyle>
                    )
                  );
                },
              }}
              endReached={UserComments.hasMore ? fetchMoreData : () => {}}
              itemContent={(index, data) => {
                const replyList = data?.replies
                  ? [...data.replies].reverse()
                  : [];
                return (
                  <>
                    <CommentUserDetails key={index}>
                      <div className="comment-profile">
                        <UserProfile>
                          {data?.profileImage ? (
                            <img
                              src={data?.profileImage}
                              className="profile-pic"
                              alt="profile-picture"
                            />
                          ) : (
                            <ProfilePic />
                          )}
                        </UserProfile>
                        <div />
                      </div>
                      <div className="reply-comment-container">
                        <div className="reply-comment-userinfo">
                          <div
                            className="user-name"
                            onClick={() =>
                              navigate('/profile/' + data?.username)
                            }
                          >
                            {'@' + data?.username}&nbsp;
                          </div>
                          <span className="post-time">
                            {'· ' + moment(data.updatedAt).fromNow(true)}
                          </span>
                        </div>
                        <div className="comment-text">{data.comment}</div>
                        <div>
                          <div className="commentAction">
                            <div className="likeIcon">
                              {ActionsRender(data, 'maincomment')}
                              <div>{getCommentReaction?.[0]?.data?.length}</div>
                            </div>
                            {disableCmt && (
                              <div
                                className="actionText"
                                onClick={() => showReplyInput(index)}
                              >
                                {t('HomePage.Reply')}
                              </div>
                            )}
                            {data?.user_id === getProfile?.userId &&
                              handleRenderPopup(data, 'comments')}
                          </div>
                          <div>
                            {showReplyByIndex === index &&
                              getInput('replyComment', data, 'childreply')}
                            {data?.replies?.length > 0 && (
                              <div
                                className="reply-cnt"
                                onClick={() => handleSetCommentIndex(index)}
                              >
                                <CaretDownOutlined />
                                {data?.replies?.length} {t('HomePage.Replies')}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </CommentUserDetails>
                    {showReplyComment.includes(index) && (
                      <>
                        {replyList?.slice(0, replycount).map((item, index) => (
                          <div className="userReplyComment" key={index}>
                            <CommentUserDetails>
                              <div className="comment-profile">
                                <UserProfile>
                                  {item?.profileImage ? (
                                    <img
                                      src={item?.profileImage}
                                      className="profile-pic"
                                      alt="profile-picture"
                                    />
                                  ) : (
                                    <ProfilePic />
                                  )}
                                </UserProfile>
                                <div />
                              </div>
                              <div className="reply-userinfo-container">
                                <div className="reply-userinfo">
                                  <div
                                    className="user-name"
                                    onClick={() =>
                                      navigate('/profile/' + item?.username)
                                    }
                                  >
                                    {'@' + item.username}
                                  </div>
                                  <span className="post-time">
                                    {' · ' +
                                      moment(item.updatedAt).fromNow(true)}
                                  </span>
                                </div>
                                <div className="comment-text">{item.reply}</div>
                                <div className="commentAction">
                                  <div className="likeIcon">
                                    {ActionsRender(item, 'replycomment')}
                                  </div>
                                  {item?.user_id === getProfile?.userId &&
                                    handleRenderPopup(item, 'reply', data.id)}
                                </div>
                              </div>
                            </CommentUserDetails>
                          </div>
                        ))}
                        {data?.replies?.length > replycount && (
                          <div
                            className="cmt-more"
                            onClick={() => Morecontent(data.replies)}
                          >
                            More...
                          </div>
                        )}
                      </>
                    )}
                  </>
                );
              }}
            />
          ) : disableCmt ? (
            <div className="no-comment">
              <div>{t('HomePage.firstCommenter')}</div>
            </div>
          ) : (
            <></>
          )}
        </CommentBox>
      ) : <></>}
    </CommentContainer>
  );
};

export default Comments;
